import { render, staticRenderFns } from "./ManageReportBenchmarksForm.vue?vue&type=template&id=4b68bbac&scoped=true"
import script from "./ManageReportBenchmarksForm.vue?vue&type=script&lang=ts"
export * from "./ManageReportBenchmarksForm.vue?vue&type=script&lang=ts"
import style0 from "./ManageReportBenchmarksForm.vue?vue&type=style&index=0&id=4b68bbac&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b68bbac",
  null
  
)

export default component.exports